module.exports = __webpack_public_path__ + "img/burrito.b956fb67.png";